import { VariableType } from 'json-to-graphql-query';
import { GroupVariables, GroupArgs, UpdateGroupVariables, UpdateGroupArgs } from './queryVariables/group';
import { EntityResource } from './entity.resource';
/**
 * Resource grup
 *
 * @export
 * @class GroupResource
 * @extends {EntityResource<Group>}
 */
export class GroupResource extends EntityResource {
    constructor() {
        super({ entityName: 'group' });
        this.getFields = {
            id: true,
            auto: true,
            name: true,
            data: {
                field: true,
                type: true,
                number: true,
                bool: true,
                text: true,
                array: true,
                range: {
                    min: true,
                    max: true
                },
                data: true
            }
        };
        this.listFields = {
            id: true,
            auto: true,
            name: true
        };
        this.listVariables = { filters: 'GroupFilters' };
        this.addVariables = GroupVariables;
        this.addArgs = GroupArgs;
        this.updateVariables = UpdateGroupVariables;
        this.updateArgs = UpdateGroupArgs;
    }
    /**
     * Pobiera listę grup użytkownika
     *
     * @param {number} id
     * @returns {Promise<Group[]>}
     * @memberof GroupResource
     */
    async getUserGroups(id) {
        const query = this.prepareOptions({
            query: {
                __variables: { id: 'String!' },
                profile: {
                    __args: { id: new VariableType('id') },
                    id: true,
                    groups: {
                        id: true,
                        name: true,
                        auto: true
                    }
                }
            }
        });
        const data = await this.query({ query, variables: { id } }, 'profile');
        return data.groups;
    }
    /**
     * Przypisuje użytkownika do grupy
     *
     * @param {*} data
     * @returns {Promise<number>}
     * @memberof ProfileResource
     */
    async setGroupToUser(data) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: {
                    groupId: 'Int!',
                    profileId: 'Int!'
                },
                profileGroupAdd: {
                    __args: {
                        groupId: new VariableType('groupId'),
                        profileId: new VariableType('profileId')
                    }
                }
            }
        });
        return await this.mutation({
            mutation,
            variables: { ...data }
        });
    }
    /**
     * Usuwa przypisanie użytkownika do grupy
     *
     * @param {*} data
     * @memberof GroupResource
     */
    async unassignFromGroup(data) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: { profileId: 'Int!', groupId: 'Int!' },
                profileGroupDelete: {
                    __args: {
                        groupId: new VariableType('groupId'),
                        profileId: new VariableType('profileId')
                    }
                }
            }
        });
        try {
            await this.mutation({ mutation, variables: { ...data } });
        }
        catch (error) {
            throw error;
        }
    }
}
export const groupResource = new GroupResource();
//# sourceMappingURL=group.resource.js.map